import moment from "moment";

const formatters = {
  $formatTime(str, format = "yyyy-MM-DD HH:mm") {
    return moment(new Date(str)).format(format);
  },
};

export default {
  install(app) {
    Object.entries(formatters).forEach(([key, fn]) => {
      app.config.globalProperties[key] = fn;
    });
  },
};
